import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import axios from 'src/lib/axios';
import { formatResourcePath } from 'src/utils/regex';

import type { MutationConfig } from 'src/lib/react-query';
import type { GeneralSmartParkAllErrors } from 'src/types';

const RESOURCE = '/forgot-password/';

const formSchema = z.object({
    email: z.string().email(),
});
type FormSchemaValues = z.infer<typeof formSchema>;

interface DTO extends FormSchemaValues {}

type MutationFnType = typeof mutationFn;
const mutationFn = (data: DTO): Promise<null> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkAllErrors> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as FORGOT_PASSWORD_RESOURCE,
    formSchema as forgotPasswordSchema,
    useMutationHook as useForgotPassword,
};
export type { DTO as ForgotPasswordDTO, FormSchemaValues as ForgotPasswordPayload };
